module.exports = __webpack_public_path__ + "static/media/10x10.219775ed.gif";